import { useMarket } from '@/providers/market';
import { AlertTriangle } from '@/components/ui';

/**
 * `MarketApi.error` is set when the live (non-demo) path cannot load — most often
 * because the connected chain has no factory deployed, or an RPC read failed.
 * Without this the app renders a perfectly composed *empty* market, which reads as
 * a bug rather than as a network problem.
 *
 * It sits at the shell level rather than in each page because the condition is
 * market-wide: every route is equally affected, and every route would otherwise
 * have to grow its own copy of the same banner.
 */
export function MarketErrorBanner() {
  const { error } = useMarket();
  if (!error) return null;

  return (
    <div className="shell pt-4">
      <div
        role="status"
        className="flex items-start gap-3 rounded-lg border border-warn/40 bg-warn/10 px-4 py-3"
      >
        <AlertTriangle size={16} className="mt-0.5 shrink-0 text-warn" />
        <div className="min-w-0">
          <p className="text-sm font-medium text-fg">No market data</p>
          <p className="mt-0.5 text-xs leading-relaxed text-muted">{error}</p>
        </div>
      </div>
    </div>
  );
}
